import { pageHead, unavailableHead, hasUnavailableMatch } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/_public/")({
  head: ({ matches }) => hasUnavailableMatch(matches) ? unavailableHead() : pageHead("Non-Electric Dog, Deer & Garden Fence Installation | Modern Fence Install", "A real fence that protects your property without blocking the view. Nearly invisible, non-electric dog, deer, and garden fencing \u2014 engineered and professionally installed.", "/", false),
  component: Index,
});
